const base = require("./base");
module.exports = {
  ...base.apiFactory(),
  _chat_190606: "https://frontend.cjdropshipping.cn/chat/", // 聊天跳转地址
  _phone_190606: "http://m.cjdropshipping.cn/", // m站挑战地址
};
